import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ToggleSwitch({ checked, onChange, disabled = false }) {
    const handleChange = (e)=>{
        onChange(e.target.checked);
    };
    return /*#__PURE__*/ _jsxs("label", {
        className: "relative inline-flex items-center cursor-pointer",
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "checkbox",
                checked: checked,
                onChange: handleChange,
                disabled: disabled,
                className: "sr-only peer"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"
            })
        ]
    });
}
